import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getAnalyticsChartData } from "../../../config/service";
import ChartLoader from "./Loading";

const DropOffChart = ({
  utm,
  toDate,
  fromDate,
  isLoader,
  setIsLoader,
  activeTab,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    handleFetchData();
  }, [utm, toDate, activeTab]);

  const handleFetchData = async () => {
    try {
      setIsLoader(true);
      const response = await getAnalyticsChartData({
        type: "dropoff",
        utm: utm?.value || "",
        dateFrom: fromDate ? fromDate.toISOString().split("T")[0] : "",
        dateTo: toDate ? toDate.toISOString().split("T")[0] : "",
      });
      console.log("Fetched drop-off data:", response);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching drop-off data:", error);
    } finally {
      setIsLoader(false);
    }
  };

  if (isLoader || !data) return <ChartLoader isLoader={isLoader} />;
  if (!isLoader && (!data || data.length === 0))
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <h4>No data available</h4>
      </div>
    );

  const options = {
    chart: { type: "bar" },
    xaxis: {
      categories: data?.map((s) => `Step ${s.stepNumber}`),
    },
  };

  const series = [
    {
      name: "Users Dropped",
      data: data.map((s) => s.count),
    },
  ];

  return <Chart options={options} series={series} type="bar" height={400} />;
};

export default DropOffChart;
